<template>
  <div id="news">
    <div class="search">
      <div class="cs-searchbar">
        <i class="cs-search"></i>
        <input class="form-control" type="search" placeholder="Zoeken binnen nieuws" />
      </div>

      <div class="search-filters">
        <ul>
          <li>
            <a
              class="nav-link"
              href="#"
              id="profiledropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="form-check">
                <input class="form-check-input" name="dekking" type="radio" value id="dekking" />
                <label class="form-check-label" for="dekking">
                  <span></span>
                  {{ i18n.app.components.news.filter_by_type }}
                </label>
              </div>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <ul>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="berichtensoort"
                    type="radio"
                    value
                    id="alleberichten"
                  />
                  <label class="form-check-label" for="alleberichten">
                    <span></span>
                    {{ i18n.app.components.news.all_messages }}
                  </label>
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="berichtensoort"
                    type="radio"
                    value
                    id="interneberichten"
                  />
                  <label class="form-check-label" for="interneberichten">
                    <span></span>
                    {{ i18n.app.components.news.internal_messages }}
                  </label>
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="berichtensoort"
                    type="radio"
                    value
                    id="socialmediaberichten"
                  />
                  <label class="form-check-label" for="socialmediaberichten">
                    <span></span>
                    {{ i18n.app.components.news.social_media_messages }}
                  </label>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a
              class="nav-link"
              href="#"
              id="profiledropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="form-check">
                <input class="form-check-input" name="limieten" type="radio" value id="limieten" />
                <label class="form-check-label" for="limieten">
                  <span></span>
                  {{ i18n.app.components.news.filters.new_messages_first }}
                </label>
              </div>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <ul>
                <li class="form-check">
                  <input class="form-check-input" name="limieten" type="radio" value id="weinig" />
                  <label class="form-check-label" for="weinig">
                    <span></span>
                    {{ i18n.app.components.news.filters.show_where_insufficient }}
                  </label>
                </li>
                <li class="form-check">
                  <input class="form-check-input" name="limieten" type="radio" value id="veel" />
                  <label class="form-check-label" for="veel">
                    <span></span>
                    {{ i18n.app.components.news.filters.show_where_sufficient }}
                  </label>
                </li>
                <li class="form-check">
                  <input
                    class="form-check-input"
                    name="limieten"
                    type="radio"
                    value
                    id="binnenlimieten"
                  />
                  <label class="form-check-label" for="binnenlimieten">
                    <span></span>
                    {{ i18n.app.components.news.within_limits }}
                  </label>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div id="content">
      <h1>
        Nieuws
        <span>(16 berichten)</span>
      </h1>
      <div class="row mr-2">
        <div class="col-md-3" v-for="index in 19" :key="index">
          <div class="card post-item">
            <div class="card-img-top" style="background-image: url('/assets/img/sample.jpg')">
              <a href="nieuws-detail.php">
                <span class="date">2 augustus 2019</span>
              </a>
            </div>
            <a href="nieuws-detail.php">
              <div class="card-body">
                <h2 class="card-title">Reserveer ‘m nu!</h2>
                <p
                  class="card-text"
                >Mos eatem quam remporiae sequunt offic to inusm adi en El ius et quodi nullaut eos debis deruns dolupta tiumquam</p>
                <button class="btn btn-primary read-more">
                  <i class="cs-arrow-right"></i>
                </button>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
